import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { HyperlinkToolbarAppearance } from '../ui/HyperlinkToolbarAppearance';
import { ToolbarViewedEvent } from '../ui/ToolbarViewedEvent';
var getToolbarViewedItem = function getToolbarViewedItem(link) {
  return [{
    type: 'custom',
    fallback: [],
    render: function render(editorView) {
      return /*#__PURE__*/React.createElement(ToolbarViewedEvent, {
        key: "edit.link.menu.viewed",
        url: link,
        display: "url",
        editorView: editorView
      });
    }
  }];
};
export var mountHyperlinkPlugin = function mountHyperlinkPlugin(pluginInjectionApi, options) {
  return new SafePlugin({
    view: function view(editorView) {
      requestAnimationFrame(function () {
        var _pluginInjectionApi$h, _pluginInjectionApi$c2, _pluginInjectionApi$c3;
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$h = pluginInjectionApi.hyperlink) === null || _pluginInjectionApi$h === void 0 || (_pluginInjectionApi$h = _pluginInjectionApi$h.actions) === null || _pluginInjectionApi$h === void 0 || _pluginInjectionApi$h.prependToolbarButtons({
          items: function items(state, intl, providerFactory, link) {
            return [].concat(_toConsumableArray(getToolbarViewedItem(link)), [{
              type: 'custom',
              fallback: [],
              render: function render(editorView) {
                var _pluginInjectionApi$a, _pluginInjectionApi$c;
                return /*#__PURE__*/React.createElement(HyperlinkToolbarAppearance, {
                  key: "link-appearance",
                  url: link,
                  intl: intl,
                  editorView: editorView,
                  editorState: state,
                  cardOptions: options,
                  providerFactory: providerFactory,
                  platform: options === null || options === void 0 ? void 0 : options.platform,
                  editorAnalyticsApi: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions,
                  cardActions: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.card) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.actions
                });
              }
            }]);
          },
          onEscapeCallback: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.card) === null || _pluginInjectionApi$c2 === void 0 ? void 0 : _pluginInjectionApi$c2.actions.hideLinkToolbar,
          onInsertLinkCallback: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c3 = pluginInjectionApi.card) === null || _pluginInjectionApi$c3 === void 0 ? void 0 : _pluginInjectionApi$c3.actions.queueCardsFromChangedTr,
          view: editorView,
          skipAnalytics: true
        });
      });
      return {};
    }
  });
};